import React from "react";
import HecRasHelper from "../Helpers/HecRasHelper";

const ProjectActions = {
    SET_BASE_PROJECT: 'SET_BASE_PROJECT',
    SET_COMPARE_PROJECT: 'SET_COMPARE_PROJECT',
    REMOVE_BASE_PROJECT: 'REMOVE_BASE_PROJECT',
    REMOVE_COMPARE_PROJECT: 'REMOVE_COMPARE_PROJECT',
    SET_PROJECT_HISTORY: 'SET_PROJECT_HISTORY',
    SET_INTERNAL_SELECTED_ID: 'SET_INTERNAL_SELECTED_ID',
    SET_SELECTED_REPORT_ID: 'SET_SELECTED_REPORT_ID',
    SET_COMPARISON_BASE_ID: 'SET_COMPARISON_BASE_ID',
    SET_COMPARISON_CMP_ID: 'SET_COMPARISON_CMP_ID',
    SET_INTERNAL_RIVER_KEY: 'SET_INTERNAL_RIVER_KEY',
    SET_COMPARISON_BASE_RIVER_KEY: 'SET_COMPARISON_BASE_RIVER_KEY',
    SET_COMPARISON_CMP_RIVER_KEY: 'SET_COMPARISON_CMP_RIVER_KEY',
    SET_FILTER: 'SET_FILTER',
    SET_SUMMARY: 'SET_SUMMARY',
    CLEAR_HISTORY: "CLEAR_HISTORY",
    SET_SORT: "SET_SORT",
    SET_OPERATION_TITLE: 'SET_OPERATION_TITLE',
    SET_CURRENT_TAB: 'SET_CURRENT_TAB',
    SET_TAB_COMPONENT: 'SET_TAB_COMPONENT',
    SET_PLAN_OVERVIEW: 'SET_PLAN_OVERVIEW'
}

export const DefaultProject = {
    type: 'def',
    information: {
        folderName: '',
        title: '',
        descriptions: [],
        text: '',
        programVersion: '',
        outputColumns: [],
    },
    projectFiles: [],
    files: [],
}

const defaultValue = {
    baseProject: DefaultProject,
    compareProject: DefaultProject,
    projectHistory: [],
    projectSummaries: [],
    updateSummary: 0,
    internalSelectedId: '',
    comparisonBaseId: '',
    comparisonCmpId: '',
    internalRiverKey: null,
    comparisonBaseRiverKey: null,
    comparisonCmpRiverKey: null,
    selectedReportId: '',
    filterHistory: [],
    filter: {
        filterType: 'filter',
        check: {
            ds: null,
            us: null
        },
        comparison: {
            ds: null,
            us: null
        }
    },
    sort: 'ds',
    operationTitle: '',
    currentTab: 'Message',
    tabComponent: null,

}

const ProjectContext = React.createContext(defaultValue)

function projectReducer(state, action) {
    switch (action.type) {
        case ProjectActions.SET_BASE_PROJECT: {
            return {
                ...state,
                baseProject: {
                    ...action.data,
                    type: 'base'
                }
            }
        }
        case ProjectActions.SET_COMPARE_PROJECT: {
            const project = HecRasHelper.checkProjectFiles(action.data)

            return {
                ...state,
                compareProject: {
                    ...project,
                    type: 'compare'
                },
            }
        }
        case ProjectActions.REMOVE_BASE_PROJECT: {
            return {
                ...state,
                baseProject: DefaultProject,
            }
        }
        case ProjectActions.REMOVE_COMPARE_PROJECT: {
            return {
                ...state,
                compareProject: DefaultProject
            }
        }
        case ProjectActions.SET_PROJECT_HISTORY: {
            const history = action.data;
            const stateX = {
                ...state,
                projectHistory: action.data
            }

            if(action.data[history.length-1]) {
                stateX.selectedReportId = action.data[history.length-1].id
            }

            return stateX
        }
        case ProjectActions.SET_INTERNAL_SELECTED_ID: {
            return {
                ...state,
                internalSelectedId: action.data
            }
        }
        case ProjectActions.SET_INTERNAL_RIVER_KEY: {
            return {
                ...state,
                internalRiverKey: action.data
            }
        }
        case ProjectActions.SET_COMPARISON_BASE_RIVER_KEY: {
            return {
                ...state,
                comparisonBaseRiverKey: action.data
            }
        }
        case ProjectActions.SET_COMPARISON_CMP_RIVER_KEY: {
            return {
                ...state,
                comparisonCmpRiverKey: action.data
            }
        }
        case ProjectActions.SET_COMPARISON_BASE_ID: {
            return {
                ...state,
                comparisonBaseId: action.data
            }
        }
        case ProjectActions.SET_COMPARISON_CMP_ID: {
            return {
                ...state,
                comparisonCmpId: action.data
            }
        }
        case ProjectActions.SET_SELECTED_REPORT_ID: {
            return {
                ...state,
                selectedReportId: action.data
            }
        }
        case ProjectActions.SET_SORT: {
            const histories = state.projectHistory.map(h => {
                return {
                    ...h,
                    operations: HecRasHelper.sortOperationsResults({
                        direction: action.data.sort,
                        operations: h.operations
                    })
                }
            })


            return {
                ...state,
                projectHistory: histories,
                sort: action.data.sort
            }
        }
        case ProjectActions.SET_FILTER: {
            const emptyFilter = {
                ds: null,
                us: null
            }

            let _state = {...state}

            _state.filter.filterType = action.data.filterType || 'filter'
            _state.filter.type = action.data.type

            let history = _state.projectHistory.find(x => x.id === action.data.id)
            let filter = {}

            if(action.data.type === 'check') {
                if(!_state.internalSelectedId)
                    _state.filter.check = emptyFilter
                else
                    _state.filter.check = action.data.filter

                filter = {
                    ..._state.filter.check,
                    filterType: action.data.filterType
                }
            }
            else {
                if(!_state.comparisonCmpId)
                    _state.filter.comparison = emptyFilter
                else
                    _state.filter.comparison = action.data.filter

                filter = {
                    ..._state.filter.comparison,
                    filterType: action.data.filterType
                }
            }

            if(history) {
                history.operations = HecRasHelper.filterResult({
                    operations: history.operations,
                    filter: {...action.data.filter, filterType: action.data.filterType}
                })
                history.filter = filter
            }

            return {
                ..._state
            }
        }
        case ProjectActions.SET_SUMMARY: {
            let _state = {...state}
            _state.updateSummary += 1;
            const index = _state.projectSummaries.findIndex(x => x.id === action.data.id)
            if(index >= 0) {
                _state.projectSummaries[index] = {
                    ..._state.projectSummaries[index],
                    id: action.data.id,
                    summary: action.data.summary
                }
            }
            else {
                _state.projectSummaries.push({
                    id: action.data.id,
                    summary: action.data.summary
                })
            }

            return {
                ..._state
            }
        }
        case ProjectActions.CLEAR_HISTORY: {
            return {
                ...state,
                projectHistory: []
            }
        }
        case ProjectActions.SET_OPERATION_TITLE: {
            return {
                ...state,
                operationTitle: action.data
            }
        }
        case ProjectActions.SET_CURRENT_TAB: {
            return {
                ...state,
                currentTab: action.data,
                disableTabs: action.disableTabs
            }
        }
        case ProjectActions.SET_TAB_COMPONENT: {
            return {
                ...state,
                tabComponent: action.data,
            }
        }
        default: {
            return state
        }
    }
}

function ProjectProvider({children}) {
    const [project, dispatch] = React.useReducer(projectReducer, defaultValue)

    const value = {project, dispatch}

    return (
        <ProjectContext.Provider value={value}>
            {children}
        </ProjectContext.Provider>
    )
}

function useProject() {
    const context = React.useContext(ProjectContext)

    if(!context)
        throw new Error('Project Provider Error')

    const {project, dispatch} = context;

    const setBaseProject = (project) => {
        dispatch({
            type: ProjectActions.SET_BASE_PROJECT,
            data: project
        })
    }

    const setCompareProject = (project) => {
        dispatch({
            type: ProjectActions.SET_COMPARE_PROJECT,
            data: project
        })
    }

    const removeBaseProject = () => {
        dispatch({
            type: ProjectActions.REMOVE_BASE_PROJECT
        })
    }

    const removeCompareProject = () => {
        dispatch({
            type: ProjectActions.REMOVE_COMPARE_PROJECT
        })
    }

    const setProjectHistory = (history) => {
        dispatch({
            type: ProjectActions.SET_PROJECT_HISTORY,
            data: history
        })
    }

    const setInternalSelectedId = (id) => {
        dispatch({
            type: ProjectActions.SET_INTERNAL_SELECTED_ID,
            data: id
        })
    }

    const setInternalSelectedRiverKey = (key) => {
        dispatch({
            type: ProjectActions.SET_INTERNAL_RIVER_KEY,
            data: key
        })
    }

    const setComparisonBaseSelectedRiverKey = (key) => {
        dispatch({
            type: ProjectActions.SET_COMPARISON_BASE_RIVER_KEY,
            data: key
        })
    }

    const setComparisonCmpSelectedRiverKey = (key) => {
        dispatch({
            type: ProjectActions.SET_COMPARISON_CMP_RIVER_KEY,
            data: key
        })
    }

    const setComparisonBaseId = (id) => {
        dispatch({
            type: ProjectActions.SET_COMPARISON_BASE_ID,
            data: id
        })
    }

    const setComparisonCmpId = (id) => {
        dispatch({
            type: ProjectActions.SET_COMPARISON_CMP_ID,
            data: id
        })
    }

    const setSelectedReportId = (id) => {
        dispatch({
            type: ProjectActions.SET_SELECTED_REPORT_ID,
            data: id
        })
    }

    const setFilter = ({id, filter, type, filterType}) => {
        dispatch({
            type: ProjectActions.SET_FILTER,
            data: {id, filter, type, filterType}
        })
    }

    const setSummary = ({id, summary}) => {
        dispatch({
            type: ProjectActions.SET_SUMMARY,
            data: {id, summary}
        })
    }

    const clearHistory = () => {
        dispatch({
            type: ProjectActions.CLEAR_HISTORY,
        })
    }

    const setSort = ({sort}) => {
        dispatch({
            type: ProjectActions.SET_SORT,
            data: {
                sort: sort
            }
        })
    }

    const setOperationTitle = ({title}) => {
        dispatch({
            type: ProjectActions.SET_OPERATION_TITLE,
            data: title
        })
    }

    const setCurrentTab = ({name, disableTabs}) => {
        dispatch({
            type: ProjectActions.SET_CURRENT_TAB,
            data: name,
            disableTabs
        })
    }

    const setTabComponent = ({component}) => {
        dispatch({
            type: ProjectActions.SET_TAB_COMPONENT,
            data: component,
        })
    }

    const getHistory = () => {
        if(window.location.href.includes('')) {
            return project.projectHistory.find(x => x.id === `${project.internalSelectedId}_${project.internalRiverKey}`)
        }
        else if(window.location.href.includes('')) {
            return project.projectHistory.find(x => x.id === `${project.comparisonBaseId}-${project.comparisonCmpId}-${project.comparisonBaseRiverKey}-${project.comparisonCmpRiverKey}`)
        }
    }

    const isLibraryProject = () => {
        let plan = project?.baseProject?.projectFiles?.find(x => x.id === project.internalSelectedId)
        if(!plan) {
            plan = project?.compareProject?.projectFiles?.find(x => x.id === project.internalSelectedId)
        }

        let count=0;
        if(plan) {
            for(let i=0; i<plan.mapProfiles.length; i++) {
                const profile = plan.mapProfiles[i]
                const next_profile = plan.mapProfiles[i+1]

                if(parseFloat(next_profile?.select) - parseFloat(profile?.select) === 0.5) {
                    count++
                }
            }
        }

        return count > 3
    }

    const isFloadwayPlan = () => {
        let plan = project?.baseProject?.projectFiles?.find(x => x.id === project.internalSelectedId)
        if(!plan) {
            plan = project?.compareProject?.projectFiles?.find(x => x.id === project.internalSelectedId)
        }

        return plan?.mapProfiles?.find(x =>x.target === 'FW')
    }

    const hasProjectionFile = () => {
        let id = `${project.internalSelectedId}`
        if(window.location.href.includes('comparison-check')) {
            // id = `${project.comparisonBaseId}-${project.comparisonCmpId}`
            return false
        }

        let plan = project?.baseProject?.projectFiles?.find(x => x.id === id)
        if(plan) {
            return project?.baseProject?.projection && plan.hasGeoReferenced
        }

        plan = project?.compareProject?.projectFiles?.find(x => x.id === id)
        if(plan) {
            return project?.compareProject?.projection && plan.hasGeoReferenced
        }

        return false
    }

    const getId = () => {
        const isCompare = window.location.href.includes('comparison-check')
        let id = `${project?.internalSelectedId}_${project?.internalRiverKey}`
        if(isCompare) {
            id = `${project?.comparisonBaseId}-${project?.comparisonCmpId}-${project?.comparisonBaseRiverKey}-${project?.comparisonCmpRiverKey}`
        }

        return id
    }

    const getCurrentHistory = () => {
        return project?.projectHistory?.find(x => x.id === getId())
    }

    return {
        baseProject: project?.baseProject,
        compareProject: project?.compareProject,
        projectHistory: project?.projectHistory,
        internalSelectedId: project?.internalSelectedId,
        comparisonBaseId: project?.comparisonBaseId,
        comparisonCmpId: project?.comparisonCmpId,
        selectedReportId: project?.selectedReportId,
        filter: project?.filter,
        filterHistory: project?.filterHistory,
        summaries: project?.projectSummaries,
        updateSummary: project?.updateSummary,
        sort: project?.sort,
        internalRiverKey: project?.internalRiverKey,
        comparisonBaseRiverKey: project?.comparisonBaseRiverKey,
        comparisonCmpRiverKey: project?.comparisonCmpRiverKey,
        operationTitle: project?.operationTitle,
        currentTab: project?.currentTab,
        tabComponent: project?.tabComponent,
        hasProjectionFile,
        setTabComponent,
        setOperationTitle,
        setCurrentTab,
        isLibraryProject,
        isFloadwayPlan,
        setBaseProject,
        setCompareProject,
        removeBaseProject,
        removeCompareProject,
        setProjectHistory,
        setInternalSelectedId,
        setComparisonBaseId,
        setComparisonCmpId,
        setFilter,
        setSelectedReportId,
        setSummary,
        clearHistory,
        setSort,
        setInternalSelectedRiverKey,
        setComparisonBaseSelectedRiverKey,
        setComparisonCmpSelectedRiverKey,
        getCurrentHistory,
        getId,
        getHistory
    }
}

export {ProjectProvider, useProject}